import { ENV_VARS } from 'constants/environment.constants';
import { HttpStatusCodeResponse } from 'constants/http-statuscodes';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { IAllGapsCategoryResponse, IReportMetaDataResponse } from 'model/interfaces';
import { AllGapsCategoryURLParams, ReportMetaDataURLParams } from 'model/types';

export const getReportHistoryDetails = async (params: any) => {
  try {
    const config = {
      url: 'overview/allpaygapstrend',
      method: 'GET',
      baseURL: ENV_VARS.API_URL as string,
      params,
    };
    const response = await kf1AuthenticatedHttpClient(config);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching report history details:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};

export const fetchReportBreakdownDetails = async (params: AllGapsCategoryURLParams) => {
  try {
    const config = {
      url: 'v2/paygaps/distributiondetails',
      method: 'GET',
      baseURL: ENV_VARS.API_URL as string,
      params,
    };
    const response = await kf1AuthenticatedHttpClient<IAllGapsCategoryResponse>(config);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching report breakdown details:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};

export const getReportHistoryData = async (params: any) => {
  try {
    const config = {
      url: 'report/versionhistory',
      method: 'GET',
      baseURL: ENV_VARS.API_URL as string,
      params,
    };
    const response = await kf1AuthenticatedHttpClient(config);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching report history data:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};

export const getReportMetaData = async (params: ReportMetaDataURLParams) => {
  try {
    const config = {
      baseURL: ENV_VARS.API_URL,
      url: 'v2/elements/reportmetadata',
      method: 'GET',
      params,
    };
    const response = await kf1AuthenticatedHttpClient<IReportMetaDataResponse>(config);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching report meta data:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};

export const downloadUploadedDocument = async (params: any) => {
  try {
    const config = {
      url: 'download/presignedurl',
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
      params,
    };
    const response = await kf1AuthenticatedHttpClient(config);
    return response.data;
  } catch (error: any) {
    console.error('Error downloading uploaded document:', error);
    return error?.response?.data ?? HttpStatusCodeResponse.InternalServerError;
  }
};
